export const getPlansParams = ({ appstore_only = false, onboardingData }) => {
  return {
    appstore_only,
    category_id: onboardingData.age_select,
    user_type:
      onboardingData.choose_path === "parent"
        ? "child_and_adolescent"
        : onboardingData.choose_path,
  };
};
